import { ReactNode } from 'react';

import { TooltipPosition } from 'component/Layout/Tooltip/types';

export enum BadgeType {
    BOX = 'Box',
    CIRCLE = 'Circle',
    PLECTRUM = 'Plectrum',
    RIBBON = 'Ribbon',
    BANDEROLE = 'Banderole',
}

export interface BadgeProps {
    /** The type of the badge */
    type?: BadgeType;

    /** background or border color */
    customClass?: string;

    /** tooltip content*/
    tooltipContent?: ReactNode;
    tooltipConfig?: {
        overlayClassName?: string;
        placement?: TooltipPosition;
        align?: {
            offset: number[];
        };
    };

    /** React children */
    children?: ReactNode;
}
